import React from 'react';
import ReactEcharts from "echarts-for-react";
import { useColorMode } from '../../../../theme/ColorModeProvider';
import { getChartPalette } from '../../../../theme/colorMode';

const BarHorizontalChartWrapper = ({
    data,
    dataKeyYAxis,
    title
}) => {
    const { mode } = useColorMode();
    const chart = getChartPalette(mode);

    return (
        <div>
            <ReactEcharts
                option={{
                    height: '80%',
                    title: {
                        text: title ? title : '',
                        textStyle: { color: chart.text }
                    },
                    legend: { textStyle: { color: chart.text } },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '1%',
                        right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        axisLabel: { color: chart.axis },
                        splitLine: { lineStyle: { color: chart.grid } },
                    },
                    yAxis: {
                        type: 'category',
                        data: dataKeyYAxis,
                        axisLabel: { color: chart.axis },
                    },
                    series: data
                }} />
        </div>
    );
};

export default BarHorizontalChartWrapper;